import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserProfileProducts } from "../api/get-user-products";
import { handleApiError, ApiError } from "../../../common/utils/api-utils";

export const fetchUserProfileProducts = createAsyncThunk(
    'userProfile/fetchUserProfileProducts',
    async (productId: string, thunkAPI) => {
      try {
        return await getUserProfileProducts(productId);
      } catch (error) {
        console.error(error);
        if (error instanceof ApiError) {
          handleApiError(error);
        }
        return thunkAPI.rejectWithValue(error);
      }
    }
  );
  